module.exports = __webpack_public_path__ + "static/media/profile-vector.0956fa63.png";